import styles from "./notFound.module.scss";
import notFound from "../../assets/imgs/404.jpg";

const NotFound = () => {
  return (
    <main className={styles.notFound}>
      <img src={notFound} alt="not-found-img" />
    </main>
  );
};

export default NotFound;
